import { Box, Collapse, Grid, type SxProps, type Theme } from "@mui/material";
import type { JSX, PropsWithChildren } from "react";
import { useState } from "react";
import ExpandCollapseButton from "../builder/ExpandCollapseButton";

interface Props {
  collapseElement?: JSX.Element | JSX.Element[] | undefined;
  expandCollapsePaddingTop?: number;
  hideBorder?: boolean;
  containerSx?: SxProps<Theme>;
  defaultCollapsed?: boolean;
}

export const CollapseContainer = (props: PropsWithChildren<Props>) => {
  const { collapseElement, children, expandCollapsePaddingTop, hideBorder, containerSx, defaultCollapsed } = props;

  const [showFields, setShowFields] = useState(!defaultCollapsed);

  return (
    <Grid container sx={{ position: "relative", width: "unset", ...containerSx }}>
      <Collapse
        orientation="horizontal"
        in={showFields}
        sx={{
          ".MuiCollapse-wrapperInner": {
            display: "grid",
            flex: 1,
          },
        }}
      >
        {children}
      </Collapse>
      <Collapse
        orientation="horizontal"
        in={!showFields}
        sx={{
          ".MuiCollapse-wrapperInner": {
            display: "grid",
            flex: 1,
          },
        }}
      >
        <Box
          sx={(theme) => ({
            borderRight: hideBorder ? "none" : `1px solid ${theme.palette.divider}`,
            pt: 5,
            width: "63px",
          })}
        >
          <Box sx={{ opacity: showFields ? 0 : 1, transition: "1s ease" }}>{!showFields && collapseElement}</Box>
        </Box>
      </Collapse>
      <ExpandCollapseButton
        variant={showFields ? "collapse" : "expand"}
        paddingTop={expandCollapsePaddingTop}
        onClick={() => setShowFields(!showFields)}
      />
    </Grid>
  );
};

export default CollapseContainer;
